#@import GliveBooking.FilteredCollections.Base
#@export GliveBooking.FilteredCollections.Events

class GliveBooking.FilteredCollections.Events extends GliveBooking.FilteredCollections.Base

  getDates: ->
    dates = _.sortBy(@map((event) -> event.getTime()), (time) -> time.start())

  getTimes: ->
    times = @map((event) -> event.getTime())

  getSections: ->
    sections = @map((event) -> event.getSection())

  getQuantities: ->
    allQuantityOptions = @map((event) -> event.getQuantityOptions())
    _.chain(allQuantityOptions)
      .flatten()
      .uniq()
      .sortBy((num) -> num)
      .value()

  getPrices: ->
    prices =  @map((event) -> event.getPrice())

  setDateFilter: (moment) ->
    return unless moment?
    @removeFilter('dates')
    @_selectedDate = moment
    @filterBy('dates', { time: (eventTime) ->
      eventTime.start().format('L') == moment.format('L')
    })

  setTimeFilter: (time) ->
    return unless time?
    @removeFilter('times')
    @_selectedTime = time
    @filterBy('times', { time: (eventTime) ->
      eventTime.start().format('HH:mm') == time.start().format('HH:mm')
    })

  setQuantityFilter: (quantity) ->
    return unless quantity?
    @removeFilter('quantities')
    @_selectedQuantity = quantity
    @filterBy('quantities', (event) ->
      event.getUserMin() <= quantity <= event.getMaxQuantity()
    )

  setPriceFilter: (price) ->
    return unless price?
    @removeFilter('prices')
    @_selectedPrice = price
    @filterBy('prices', (event) ->
      event.getPrice().getPrice() == price.getPrice()
    )

  setSectionFilter: (section) ->
    return unless section?
    @removeFilter('sections')
    @_selectedSection = section
    @filterBy('sections', (event) ->
      event.getSection().getTitle() == section.getTitle()
    )

  getMinQuantity: ->
    return 0 unless this.length > 0
    _.min(@map((event) -> event.getUserMin()))

  getMaxQuantity: ->
    return 0 unless this.length > 0
    _.max(@map((event) -> event.getMaxQuantity()))
